import { render } from "./ReceiverManagementFullscreenModal.vue?vue&type=template&id=0e48a517"
import script from "./ReceiverManagementFullscreenModal.vue?vue&type=script&lang=js"
export * from "./ReceiverManagementFullscreenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__